// A `lockerDoorReservationSession` is a soft advisory lock: an operator holds
// a door while filling the reservation form, and every other operator sees
// that door as "reserving" and cannot click it. Extracted here so the window
// predicate is unit-testable and shared verbatim by the V1 door tile
// (useReservation) and the V2 one (OsLockerDoorV2) — DEV-201.

export type ReservationSessionWindow = {
  sessionStart: number
  sessionEnd?: number
}

/**
 * Is this soft lock currently held?
 *
 * Open-ended by design: sessions are created with a `sessionStart` only, and
 * are released by an explicit delete (drawer close, door switch, reservation
 * created) or reaped by `fnCheckReservationSessions`. A missing `sessionEnd`
 * therefore means "still held", not "expired".
 *
 * Callers must additionally suppress this when the door carries a real
 * reservation — a parcel always outranks an intent.
 */
export const isReservationSessionActive = (
  session: ReservationSessionWindow | undefined | null,
  now: number,
): boolean => {
  if (!session) return false
  if (typeof session.sessionStart !== "number") return false
  return (
    session.sessionStart < now && (!session.sessionEnd || session.sessionEnd > now)
  )
}
